<template>
    <div>
        <div class="card dashcard mb-3">
            
            <div class="card-body">

                <div class="row">
                    <div class="col col-12 col-md-9">
                        <az-input 
                            icon="fas fa-search" 
                            v-model="search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="false">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="expandido = !expandido">
                                        <i class="fas fa-expand-arrows-alt fa-fw" v-if="!expandido"></i>
                                        <i class="fas fa-compress-arrows-alt fa-fw" v-else></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'A'">
                                Com Saldo
                            </button>
                            <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'T'">
                                Todos
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <az-empty-state 
            v-if="!dados || !dados.lista.length" 
            icon="fas fa-funnel-dollar"
            msg="Nenhum adiantamento identificado." />

        <table class="table bg-white" v-else>
            <template v-for="(fornecedor, igx) in lista_exibicao">
                <tr :key="igx" class="table-info">
                    <th colspan="3">
                        <a href="#" @click.prevent="fornecedor.expandido = !fornecedor.expandido" class="card-link text-dark  mr-2">
                            <i class="fa fa-plus-square-o fa-fw" aria-hidden="true" v-if="!fornecedor.expandido"></i>
                            <i class="fa fa-minus-square-o fa-fw" aria-hidden="true" v-else></i>
                        </a>
                        {{ fornecedor.search }}        
                    </th>
                    <th class="text-right">
                        {{ $util.formatMoeda(fornecedor.saldo_adiantamentos) }}
                        <i class="fa fa-circle text-primary fa-fw" aria-hidden="true"></i>
                    </th>
                </tr>
                <template v-for="(baixa, ibx) in fornecedor.baixas">
                    <tr :key="igx + '.' + ibx" v-if="fornecedor.expandido" 
                        :class="baixa.tipo_lancamento == 'C' ? 'table-success' : 'table-danger'">
                        <td>
                            <a href="#" @click.prevent="editar(baixa)" class="card-link">
                                #{{ baixa.id_lancamento }}
                            </a>
                        </td>
                        <td>{{ $util.getFormatDate(baixa.dt_baixa) }}</td>
                        <td class="text-right">
                            {{ $util.formatMoeda(baixa.valor_liquido) }}
                            <i class="fa fa-plus-circle fa-fw text-success" aria-hidden="true" v-if="baixa.tipo_lancamento == 'C'"></i>
                            <i class="fa fa-minus-circle fa-fw text-danger" aria-hidden="true" v-if="baixa.tipo_lancamento == 'D'"></i>
                        </td>
                        <td class="text-right">
                            {{ $util.formatMoeda(baixa.saldo) }}
                            <i class="fa fa-circle text-primary fa-fw" aria-hidden="true"></i>
                        </td>
                    </tr> 
                </template>
            </template>
        </table>

        <pre class="alert alert-info" v-if="false">{{ dados }}</pre>

        <!-- Lançamento -->
        <edicao-lancamento ref="lancamento" @refresh="load()" />

    </div>
</template>

<script>
// import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import EdicaoLancamento from './EdicaoLancamento.vue';

export default {
    data() { 
        return { 
            dados: null, 
            search: "", 
            expandido: false, 
            viewMode: "A",
            fornecedores: [], 
        }
    },

    components: { 
        AzEmptyState, 
        AzInput, 
        EdicaoLancamento, 
    }, 

    computed: { 
        lista_exibicao: function () { 
            if ( !this.dados ) { 
                return [];
            }

            let reg = this.$util.getregex(this.search);

            return this.dados.lista.filter(fornecedor => 
                ( this.viewMode != 'A' || ( fornecedor && fornecedor.saldo_adiantamentos > 0 ) ) && 
                ( !this.search || reg.test(JSON.stringify(fornecedor)))
            );
        }
    },

    methods: { 
        load() { 
            this.$util.load(this, { 
                service: 'financeiro', 
                func: 'adiantamentos', 
            });
        },

        editar (item) { 
            this.$refs.lancamento.editar(item);
        },
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Financeiro", path: "/financeiro/visao" },
            { name: "Adiantamentos", path: "/financeiro/adiantamentos" }
        ]);

        this.load();
    }
}
</script>